module.exports = __webpack_public_path__ + "img/grid-lock.485dcd26.svg";